import { Routes } from '@angular/router'

import { FeatureType, RouteUtil } from '../shared'
import { BusinessPlanComponent } from './business-plan/business-plan.component'
import { leaveActiveMeetingGuard } from './leave-active-meeting.guard'
import { MeetingsComponent } from './meetings/meetings.component'

export const meetingsRoutes: Routes = [
    {
        path: 'meetings',
        children: [
            {
                ...RouteUtil.Make('meetings', MeetingsComponent, [FeatureType.MeetingsMeetingView, FeatureType.MeetingsMeetingEdit]),
                canDeactivate: [leaveActiveMeetingGuard],
            },
            RouteUtil.Make('business-plan', BusinessPlanComponent, FeatureType.MeetingsMeetingView),
        ],
    },
]
